var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 16,
    fill: "url(#paint0_linear_15263_36588)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4178 12.8125C19.9701 12.8125 20.4178 13.2602 20.4178 13.8125V14.5331H29.4147V13.8125C29.4147 13.2602 29.8624 12.8125 30.4147 12.8125C30.967 12.8125 31.4147 13.2602 31.4147 13.8125V14.5331H33.6845C35.5321 14.5331 37.1656 15.9361 37.1656 17.8278V33.8908C37.1656 35.7825 35.5321 37.1855 33.6845 37.1855H16.317C14.4694 37.1855 12.8359 35.7825 12.8359 33.8908V22.0522V17.8278C12.8359 15.9361 14.4694 14.5331 16.317 14.5331H18.4178V13.8125C18.4178 13.2602 18.8655 12.8125 19.4178 12.8125ZM14.8359 33.8908V23.0522H35.1656V33.8908C35.1656 34.5338 34.5774 35.1855 33.6845 35.1855H16.317C15.4241 35.1855 14.8359 34.5338 14.8359 33.8908ZM14.8359 21.0522H35.1656V17.8278C35.1656 17.1848 34.5774 16.5331 33.6845 16.5331H31.4147V17.2546C31.4147 17.8069 30.967 18.2546 30.4147 18.2546C29.8624 18.2546 29.4147 17.8069 29.4147 17.2546V16.5331H20.4178V17.2546C20.4178 17.8069 19.9701 18.2546 19.4178 18.2546C18.8655 18.2546 18.4178 17.8069 18.4178 17.2546V16.5331H16.317C15.4241 16.5331 14.8359 17.1848 14.8359 17.8278V21.0522ZM24.6571 25.153C25.2094 25.153 25.6571 25.6007 25.6571 26.153V27.656H27.364C27.9163 27.656 28.364 28.1037 28.364 28.656C28.364 29.2082 27.9163 29.656 27.364 29.656H25.6571V31.1596C25.6571 31.7119 25.2094 32.1596 24.6571 32.1596C24.1048 32.1596 23.6571 31.7119 23.6571 31.1596V29.656H21.9508C21.3985 29.656 20.9508 29.2082 20.9508 28.656C20.9508 28.1037 21.3985 27.656 21.9508 27.656H23.6571V26.153C23.6571 25.6007 24.1048 25.153 24.6571 25.153Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15263_36588",
    x1: 50,
    y1: 0.00000160187,
    x2: -3.75,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443569,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActive);
export default __webpack_public_path__ + "static/media/calendar-active.cdda82618b0c5a52b0014a0a44d2277d.svg";
export { ForwardRef as ReactComponent };